<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/K0uTB0/tc-custom/9781035856794.jpg?1737331038803" alt="This image is the cover for the book Two Little Birds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two Little Birds
      </h1>
      <p class="bookDescription body article font2">
        <p>Two Little Birds is an enchanting tale for readers of all ages. This captivating story follows two small birds as they navigate challenges through the power of communication, encouraging readers to be brave, strong, and unafraid. Rich with wisdom and curiosity, the narrative resonates with the throat chakra, highlighting the importance of finding peace and energy through expression. The book emphasizes how communication is a powerful trait, requiring courage and strength to truly convey one’s feelings and thoughts. Join these two little birds on their adventure and be swept away by the beauty of poetic storytelling and vibrant illustrations. Discover the strength within you to harness the power of your voice. Namaste.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel Gerich
      </h2>
      
      <p class="authorDescription body article">Daniel Gerich has always been a creative figure, portraying spirituality, enlightenment, and wisdom. He has always been a writer since a young age. Daniel grew up in the southwest of Sydney, Australia, with his family and friends. He has always had a keen eye for the art of poetry, music, and nature. He absolutely loves animals, and in any spare minute, he is either writing or meditating.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04983230